import type { IResponseBase } from '@/interfaces';
import type { IWorkflow } from '@/interfaces/IWorkflow';
import type { IWorkflowActionEntry } from '@/interfaces/IWorkflowActionEntry';
import { Http, HttpService } from './http';

const http = Http.create();

export class WorkflowService {
	/**
	 * Set action value
	 * @param activityId
	 * @param action
	 */
	static async doAction(entityId: string, activityId: string, action: string) {
		const response = await http.post<IResponseBase<IWorkflow>>(
			`workflow/${entityId}/activities/${activityId}`,
			{
				action,
			},
		);

		return response.data;
	}

	static async requestMoreDocuments(
		entityId: string,
		activityId: string,
		payload: Array<{ RenterId: string; DocumentTypes: number[] }>,
	) {
		return await this.doAction(entityId, activityId, JSON.stringify(payload));
	}

	/**
	 * Get workflow activities by workflow id
	 * @param workflowId
	 * @returns
	 */
	static async getWorkflowActivities(entityId: string, workflowId: string) {
		const cancelToken = HttpService.createCancelToken('getWorkflowActivities');
		const response = await http.get<IResponseBase<IWorkflowActionEntry[]>>(
			`workflow/${entityId}/activities?workflowId=${workflowId}`,
			{ cancelToken },
		);
		HttpService.cancelTokens['getWorkflowActivities'] = null;
		return response.data;
	}

	/**
	 * Start workflow for a specific case
	 * @param caseEntityId
	 * @param caseType
	 * @returns
	 */
	static async startWorkflow(caseEntityId: string, caseType: string) {
		const response = await http.post<IResponseBase<IWorkflow>>(`workflow`, {
			caseEntityId,
			caseType,
		});

		return response.data;
	}
	/**
	 * Delete workflows associated with a case
	 * @param caseEntityId
	 * @returns
	 */
	static async deleteWorkflow(caseEntityId: string) {
		const response = await http.delete<IResponseBase<boolean>>(`workflow/case/${caseEntityId}`);
		return response.data;
	}
	
	static async forceActivityAction(activity: string, payload: object) {
		if (activity == 'DocumentSignRequestActivity') {
			const response = await http.post<IResponseBase<IWorkflow>>(
				`webhook/sign-request/d4sign`,
				payload,
			);
			return response.data;
		}
	}
}
